<!-- DetailHeader.vue -->
<template>
	<div>
		<div class="ui-detail-header">
			<span class="iconfont" @click="$router.go(-1)">&#xe6ee;</span>
			<div class="navbar-wrapper">
				<div
					v-for="(item, key) in data"
					:key="key"
					v-bind:class="{ navbar_active: key == index }"
					v-on:click="changeEvent(key)"
				>
					{{ item.name }}
					<div></div>
				</div>
			</div>
			<span class="iconfont right" @click="popupMore">&#xe680;</span>
		</div>
		<header-more v-if="share_info" :goods_id="goods_id" :share_info="share_info" v-show="popupVisible" :share_message="shareMessage"></header-more>
	</div>
</template>

<script>
import { header } from './static'
import { mapState, mapMutations } from 'vuex'
import HeaderMore from '../../HeaderMore'
export default {
	data () {
		return {
			data: header,
			popupVisible: false
		}
	},
	components: {
		HeaderMore
	},
	computed: {
		...mapState({
			commonInfo: state => state.goodsdetail.commonInfo,
			goods_id: state => state.goodsdetail.currentProductId,
			index: state => state.goodsdetail.index,
			config: state => state.config.config
		}),
		share_info: function () {
			return this.commonInfo ? { title: this.commonInfo.goods_name, link: window.location.href, imgUrl: this.commonInfo.goods_image_mobile[0], desc: this.commonInfo.goods_advword } : false
		},
		shareMessage: function () {
			const result = this.config.app_share_message_templates.find((v) => v.code === 'goods_share')
			return result.content.replace(':url', window.location.href).replace(':goods_name', this.commonInfo.goods_name)
		}
	},
	created () {
		this.changeIndex(0)
		// this.saveNumber(1)
	},
	methods: {
		...mapMutations({
			changeIndex: 'changeIndex',
			saveNumber: 'saveNumber'
		}),
		popupMore () {
			if (!this.popupVisible) {
				this.popupVisible = true
			} else {
				this.popupVisible = false
			}
		},
		changeEvent (index) {
			this.changeIndex(index)
		},
		goBack () {
			this.$router.go(-1)
		}
	}
}
</script>

<style lang="scss" scoped>
.ui-detail-header {
	padding: 0 0.45rem;
	// height:3.2rem;
	background:#f4c41e;
    height: 3.8rem;
    z-index: 999;
	border-radius: 0 0 30px 30px;
	border-bottom: 1px solid rgba(232, 234, 237, 1);
	color: black;
	font-size: 0.8rem;
	width: auto;
	display: flex;
	justify-content: center;
	align-content: center;
	align-items: center;
	flex-basis: auto;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	.iconfont {
		width: 1.2rem;
		font-size:0.8rem;
		height: 1.2rem;
		line-height:1.2rem;
		cursor: pointer;
		position: absolute;
		left: 0.45rem;
		top: 2rem;
	}
	.iconfont.right{left:auto;right:0.45rem}
	div.navbar-wrapper {
		line-height: 2.1rem;
		padding-top: 1rem;
		div {
			// line-height: 2.1rem;
			border-bottom: 0;
			display: inline-block;
			margin-right:2.4rem;
			color: #55595f;
			background-color: #fff;
			position: relative;
			font-weight: bold;
			background:#f4c41e;
			div{
				position: absolute;
				bottom: .2rem;
				width: 66%;
				left: 50%;
				height: .2rem;
				// background: #fff;
				border-radius: .5rem;
				margin-left: -33%;
			}
			&.navbar_active{
				color: white;
				div {
					background: white;
				}
			}
			&:last-child {
				margin-right: 0;
			}
			&:focus {
				outline: none;
			}
		}
	}
}

</style>
